import React, { Component } from "react";
import ShopListItem from '../shop_list_item/shop_list_item';
import Flexbox from 'flexbox-react';
import {observer} from 'mobx-react';

const componentWidths = {
    image: "26%",
    body: "56%",
    status: "19%"
};

@observer
export default class ShopListRow2Items extends Component {
    render() {
        return (
            <Flexbox width="100%" flexDirection="row">
                <Flexbox width="2%"></Flexbox>
                <Flexbox style={{color: "rgba(0, 0, 0, 0.87)"}} width="47%">
                    <ShopListItem componentWidths={componentWidths} shop={this.props.shop1}/>
                </Flexbox>

                <Flexbox width="2%"></Flexbox>

                <Flexbox style={{color: "rgba(0, 0, 0, 0.87)"}} width="47%">
                    <ShopListItem componentWidths={componentWidths} shop={this.props.shop2}/>
                </Flexbox>
                <Flexbox width="2%"></Flexbox>
            </Flexbox>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_list/shop_list_row_2_items.jsx